export default "__VITE_ASSET__CRWMKBAN__"